/**
 * Инициалы для аватара без фото — одна реализация на всю экосистему.
 *
 * Копий было шесть (оболочка витрины, карточка приглашений, форма профиля,
 * `auth-flow` входа, шаг мастера и сам кит), и они разошлись в поведении:
 * односложное «Maya» давало «M» в витрине и «MA» на экране входа. Аватар
 * одного и того же человека показывал разное число букв в зависимости от
 * того, в каком сервисе его открыли.
 *
 * Правило: две буквы. У имени из нескольких слов — первые буквы первых двух
 * слов, у односложного — две первые буквы этого слова. Отчества и вторые
 * фамилии в кружок не помещаются и делают его нечитаемым.
 *
 * Верхний регистр — через `toLocaleUpperCase`: у турецкого `i` переходит в `İ`,
 * и `toUpperCase()` дал бы там латинскую `I`.
 */
export function initialsOf(name: string | null | undefined, locale?: string): string {
	const words = (name ?? "").trim().split(/\s+/).filter(Boolean);
	// Пустое имя бывает штатно: приглашённый, который ещё не заполнил профиль.
	// Пустой кружок читается как сбой загрузки, поэтому явный знак вопроса.
	if (words.length === 0) return "?";
	const source =
		words.length === 1
			? (words[0] ?? "").slice(0, 2)
			: `${words[0]?.[0] ?? ""}${words[1]?.[0] ?? ""}`;
	return locale ? source.toLocaleUpperCase(locale) : source.toLocaleUpperCase();
}
